import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import styles from './MainLayout.module.scss';
import RequirePermission from "../components/RequirePermission";
import ErrorBoundary from "../components/ErrorBoundary";
import { useAuth } from "../providers/AuthContext";
import { useZone } from "../providers/ZoneContext";

const Stock = lazy(() => import("../pages/stock/Stock"));
const Movements = lazy(() => import("../pages/movements/Movements"));
const ProcessTransfer = lazy(() => import("../pages/processTransfer/ProcessTransfer"));
const Shipments = lazy(() => import("../pages/shipments/Shipments"));
const Capacity = lazy(() => import("../pages/Capacity/Capacity"));
const Settings = lazy(() => import("../pages/Settings"));
const TimeToSellAnalysis = lazy(() => import("../components/TimeToSellAnalysis"));
const SalesAnalysis = lazy(() => import("../pages/SalesAnalysis/SalesAnalysis"));
const Arrivals = lazy(() => import("../pages/Arrivals/Arrivals"));
const Orders = lazy(() => import("../pages/Orders/Orders"));
const Pullback = lazy(() => import("../pages/Pullback/Pullback"));
//const Chat = lazy(() => import("../pages/chat/Chat"));
const Support = lazy(() => import("../pages/Support/Support"));

function guarded(routeId, element) {
    return (
        <RequirePermission routeId={routeId}>
            {element}
        </RequirePermission>
    );
}

function PageFallback() {
    return (
        <div style={{ padding: '2rem', color: '#666' }}>
            Loading…
        </div>
    );
}

export default function MainLayout() {
    const { user, logout } = useAuth();
    const { selectedZone, updateZone } = useZone();

    return (
        <div className={styles.container}>
            <Sidebar
                user={user}
                logout={logout}
            />

            <main className={styles.content}>
                <ErrorBoundary>
                    <Suspense fallback={<PageFallback />}>
                        <Routes>
                            <Route path="/" element={<Navigate to="/stock" replace />} />
                            <Route path="/stock" element={guarded('stock', <Stock selectedZone={selectedZone} updateZone={updateZone} />)} />
                            <Route path="/movements" element={guarded('movements', <Movements selectedZone={selectedZone} updateZone={updateZone} />)} />
                            <Route path="/processTransfers" element={guarded('processTransfers', <ProcessTransfer selectedZone={selectedZone} updateZone={updateZone} />)} />
                            <Route path="/shipments" element={guarded('shipments', <Shipments selectedZone={selectedZone} updateZone={updateZone} />)} />
                            <Route path="/salesAnalysis" element={guarded('salesAnalysis', <SalesAnalysis selectedZone={selectedZone} updateZone={updateZone} />)} />
                            <Route path="/timeToSell" element={guarded('timeToSell', <TimeToSellAnalysis />)} />
                            <Route path="/capacity" element={guarded('capacity', <Capacity selectedZone={selectedZone} updateZone={updateZone} />)} />
                            <Route path="/settings" element={guarded('settings', <Settings selectedZone={selectedZone} updateZone={updateZone} />)} />
                            <Route path="/arrivals" element={guarded('arrivals', <Arrivals selectedZone={selectedZone} updateZone={updateZone} />)} />
                            <Route path="/orders" element={guarded('orders', <Orders selectedZone={selectedZone} updateZone={updateZone} />)} />
                            <Route path="/pullback" element={guarded('pullback', <Pullback selectedZone={selectedZone} updateZone={updateZone} />)} />
                            {/* <Route path="/chat" element={guarded('chat', <Chat selectedZone={selectedZone} />)} /> */}
                            <Route path="/support" element={guarded('support', <Support />)} />
                            <Route path="*" element={<Navigate to="/stock" replace />} />
                        </Routes>
                    </Suspense>
                </ErrorBoundary>
            </main>
        </div>
    );
}
